/** Stable modal names for `Modal name=` + `useModalContext` */

export const OBJECTIVES_GOAL_MOVE_MODAL = 'objectives-goal-move-modal';
export const OBJECTIVES_KEY_OBJECTIVE_MOVE_MODAL =
  'objectives-move-focus-area-modal';
export const OBJECTIVES_PROCESS_MOVE_MODAL = 'objectives-process-move-modal';

export const CAMPAIGN_PAUSE_MODAL = 'campaign-pause-modal';
export const CAMPAIGN_DUPLICATE_MODAL = 'campaign-duplicate-modal';
export const CAMPAIGN_LAUNCH_MODAL = 'campaign-launch-modal';
export const CAMPAIGN_DELETE_MODAL = 'campaign-delete-modal';

/** CRM-731 — attach PBv2 workflows to a pipeline stage */
export const PIPELINE_STAGE_ADD_WORKFLOW_MODAL =
  'pipeline-stage-add-workflow-modal';

export const BOARD_CONFIRM_STAGE_MOVE_MODAL = 'board-confirm-stage-move-modal';
